/* eslint-disable no-restricted-syntax */
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
import { isInteropableString } from "../../../../lib/utils/stringInterop";
function* visitBinding(layout) {
  if (layout.bindings) {
    for (const bindingId in layout.bindings) {
      const rawValue = layout.bindings[bindingId];
      if (rawValue) {
        yield {
          type: 'dataPath',
          place: ['bindings', bindingId],
          description: `绑定到了${bindingId}`
        };
      }
    }
  }
}
function* visitProps(layout, compMeta) {
  if (layout.props) {
    for (const propId in layout.props) {
      const propValue = layout.props[propId];
      if (!propValue) continue;
      // ----------------------------------------------
      // Case 1: 属性直接就是 { $expr: "xxx" } 的情况
      if (isExprObject(propValue)) {
        yield {
          type: 'javascript',
          place: ['props', propId, '$expr'],
          description: `属性${propId}使用了动态表达式`,
          accessType: 'read'
        };
        continue;
      }
      // ----------------------------------------------
      // Case 2: 属性可能是 花括号插值字符串 的情况
      // UICore 的规则：如果这个组件是系统注册的组件，而且定义了 allowInteropProps 那么就需要特别处理
      if (compMeta && !compMeta.allowInteropProps.includes(propId)) continue;
      if (typeof propValue === 'string') {
        yield {
          type: 'interopable-string',
          place: ['props', propId],
          description: `属性${propId}使用了插值字符串`,
          accessType: 'read'
        };
      }
    }
  }
}
function* visitStyle(layout) {
  if (layout.style) {
    for (const key in layout.style) {
      if (isInteropableString(layout.style[key])) {
        yield {
          type: 'interopable-string',
          place: ['style', key],
          description: `样式${key}`,
          accessType: 'read'
        };
      }
    }
  }
}
export const visitLayout = function* (ctx, step) {
  var _compMeta$handleColle;
  if (step.type !== 'layout') return;
  const layout = step.value;
  const compMeta = ctx.components[layout.type];
  yield* visitBinding(layout);
  // 属性中依赖的情况
  yield* visitProps(layout, compMeta);
  // 事件的情况
  if (layout.events) {
    for (const eventId in layout.events) {
      yield {
        type: 'eventFlow',
        place: ['events', eventId],
        description: `事件${eventId}`
      };
    }
  }
  // 样式的情况
  yield* visitStyle(layout);
  // className
  if (isInteropableString(layout.class)) {
    yield {
      type: 'interopable-string',
      place: ['class'],
      description: '样式类',
      accessType: 'read'
    };
  }
  // 默认插槽
  if (layout.children) {
    for (let i = 0; i < layout.children.length; i++) {
      yield {
        type: 'layout',
        place: ['children', i],
        description: `第${i}子组件`
      };
    }
  }
  // 具名插槽
  if (layout.slots) {
    for (const slotId in layout.slots) {
      const slotChildren = layout.slots[slotId];
      if (!slotChildren) continue;
      for (let i = 0; i < slotChildren.length; i++) {
        yield {
          type: 'layout',
          place: ['slots', slotId, i],
          description: `插槽${slotId}的第${i}子组件`
        };
      }
    }
  }
  if (layout.displayCondition) {
    yield {
      type: 'javascript',
      place: ['displayCondition'],
      description: '显示条件',
      accessType: 'read'
    };
  }
  if (layout.renderCondition) {
    yield {
      type: 'javascript',
      place: ['renderCondition'],
      description: '渲染条件',
      accessType: 'read'
    };
  }
  yield* (compMeta === null || compMeta === void 0 || (_compMeta$handleColle = compMeta.handleCollectDeps) === null || _compMeta$handleColle === void 0 ? void 0 : _compMeta$handleColle.call(compMeta, ctx, step)) || [];
};
//# sourceMappingURL=visitLayout.js.map
